"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _constants = require("../constants");
var _staticContent = require("../staticContent");
var _utils = require("../utils");
var _errorHandlerUtility = _interopRequireDefault(require("../utils/errorHandlerUtility"));
var _useStepTrackerContext = _interopRequireDefault(require("../hooks/useStepTrackerContext"));
var _FieldWrapper = _interopRequireDefault(require("../FieldWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var fileName = 'AddressField/index.jsx';

//Max Length Validation
var meetsMaxLength = (value, maxlength) => maxlength === undefined || value.length <= maxlength;
//Regex Validation
var meetsRegex = value => value ? _constants.LONG_SHORT_ANSWER_REGEX_VALIDATION.test(value) : true;
//Required Field Validation
//Case: If unit number is there, then validate if address is added
var meetsIsRequired = (value, isRequired, isAddSelected, unitValue) => isRequired ? isAddSelected && (value === null || value === void 0 ? void 0 : value.length) > 0 : (unitValue === null || unitValue === void 0 ? void 0 : unitValue.length) > 0 ? (value === null || value === void 0 ? void 0 : value.length) > 0 : true;

// Address Field Validation
var validate = (value, isRequired, isAddSelected, unitValue) => {
  var isValid = true;

  // If field is required, then make sure some input is provided
  isValid = isValid && meetsIsRequired(value, isRequired, isAddSelected, unitValue);

  //check if meets allowed characters
  isValid = isValid && meetsRegex(value);
  return isValid;
};

// Unit Number Validation
var validateUnitNumber = (value, maxlength) => {
  var isValid = true;

  // When given a maxlength, ensure the length is less or equal to
  isValid = isValid && meetsMaxLength(value, maxlength);

  //check if meets allowed characters
  isValid = isValid && meetsRegex(value);
  return isValid;
};
var getValueFromObject = (value, key) => {
  var valueFromObject = '';
  try {
    if (value !== '' && value !== undefined && value !== null) {
      var data = JSON.parse(value);
      if (data[key]) {
        valueFromObject = data[key];
      }
    }
  } catch (err) {
    _errorHandlerUtility.default.report(JSON.stringify({
      message: "Failed to parse value - ".concat(err),
      fileName,
      methodName: 'getValueFromObject'
    }));
  }
  return valueFromObject;
};
function getAddressQuery(option) {
  switch (option) {
    case 'TELUS':
      return 'T';
    case 'CanadaPost':
      return 'CP';
    case 'Both':
      return 'MERGE_CP';
    default:
      return 'MERGE_CP';
  }
}
var validateAddressAndUnitNumber = (value, isRequired, isAddSelected, unitValue, unitNumberMaxLength) => validate(value, isRequired, isAddSelected, unitValue) && validateUnitNumber(unitValue, unitNumberMaxLength);
var AddressField = props => {
  var {
    language = _constants.CONTENTFUL_LOCALE.en,
    label = _staticContent.ADDRESS_FIELD.DEFAULT_LABEL,
    isRequired,
    onChange = (value, isValid) => {},
    // eslint-disable-line no-unused-vars,
    clickedSubmit = false,
    placeholder,
    hint,
    hintPosition = _constants.FIELD_HINT_POSITION.BELOW,
    customErrorMessage = '',
    inputRef = /*#__PURE__*/_react.default.createRef(),
    isLPDSIDRequired = false,
    isProduction = true,
    environment = 'sandbox',
    unitNumberHint,
    unitNumberPlaceholder,
    unitNumberLabel = _staticContent.ADDRESS_FIELD.UNIT.DEFAULT_LABEL,
    unitNumberMaxLength,
    unitNumberCustomErrorMessage = '',
    isReadOnly = false,
    isPrefill = false,
    value,
    showUnitNumber = true,
    addressQuerySource = 'Both'
  } = props;
  var [addressValue, setAddressValue] = (0, _react.useState)(getValueFromObject(value, 'address'));
  var [items, setItems] = (0, _react.useState)([]);
  var [validationError, setValidationError] = (0, _react.useState)(undefined);
  var [validationFeedback, setValidationFeedback] = (0, _react.useState)(undefined);
  var [isLoading, setIsLoading] = (0, _react.useState)(true);
  var [isAddSelected, setIsAddSelected] = (0, _react.useState)(false);
  var [payloadValue, setPayloadValue] = (0, _react.useState)('');
  var [selectedAddress, setSelectedAddress] = (0, _react.useState)('');
  var {
    buttonControlPressed,
    currentStepReferences
  } = (0, _useStepTrackerContext.default)();

  // Unit Number
  var [unitNumberValue, setUnitNumberValue] = (0, _react.useState)(getValueFromObject(value, 'unit'));
  var [unitNumberFeedback, setUnitNumberFeedback] = (0, _react.useState)(undefined);
  var [unitNumberError, setUnitNumberError] = (0, _react.useState)(undefined);

  // Unit Number validation Error and Feedback
  var updateUnitNumberValidationError = (0, _react.useCallback)(value => {
    if (unitNumberCustomErrorMessage) {
      setUnitNumberError(validateUnitNumber(value, unitNumberMaxLength) ? undefined : unitNumberCustomErrorMessage);
      setUnitNumberFeedback(validateUnitNumber(value, unitNumberMaxLength) ? _constants.FIELD_FEEDBACK.SUCCESS : _constants.FIELD_FEEDBACK.ERROR);
      return;
    }
    if (!meetsMaxLength(value, unitNumberMaxLength)) {
      setUnitNumberError("".concat(_staticContent.ADDRESS_FIELD.UNIT.VALIDATION_ERROR_STRING_TOOLONG[language], " ").concat(unitNumberMaxLength));
      setUnitNumberFeedback(_constants.FIELD_FEEDBACK.ERROR);
    } else if (!meetsRegex(value)) {
      setUnitNumberError("".concat(_staticContent.ADDRESS_FIELD.UNIT.VALIDATION_ERROR_STRING_REGEX[language]));
      setUnitNumberFeedback(_constants.FIELD_FEEDBACK.ERROR);
    } else {
      setUnitNumberError(undefined);
      setUnitNumberFeedback(_constants.FIELD_FEEDBACK.SUCCESS);
    }
  }, [language, unitNumberMaxLength, unitNumberCustomErrorMessage]);

  // Address Field Validation Error and Feedback
  var updateValidationError = (0, _react.useCallback)(value => {
    if (customErrorMessage) {
      setValidationError(validate(value, isRequired, isAddSelected, unitNumberValue) ? undefined : customErrorMessage);
      setValidationFeedback(validate(value, isRequired, isAddSelected, unitNumberValue) ? _constants.FIELD_FEEDBACK.SUCCESS : _constants.FIELD_FEEDBACK.ERROR);
      return;
    }
    if (!meetsIsRequired(value, isRequired, isAddSelected, unitNumberValue)) {
      setValidationError("".concat(_staticContent.ADDRESS_FIELD.VALIDATION_ERROR[language]));
      setValidationFeedback(_constants.FIELD_FEEDBACK.ERROR);
    } else if (!meetsRegex(value)) {
      setValidationError("".concat(_staticContent.ADDRESS_FIELD.VALIDATION_ERROR_STRING_REGEX[language]));
      setValidationFeedback(_constants.FIELD_FEEDBACK.ERROR);
    } else if (value && (0, _utils.normalizeAddress)(value) !== (0, _utils.normalizeAddress)(selectedAddress)) {
      setValidationError("".concat(_staticContent.ADDRESS_FIELD.VALIDATION_ERROR[language]));
      setValidationFeedback(_constants.FIELD_FEEDBACK.ERROR);
    } else {
      setValidationError(undefined);
      setValidationFeedback(_constants.FIELD_FEEDBACK.SUCCESS);
    }
  }, [customErrorMessage, selectedAddress, isRequired, language, unitNumberValue, isAddSelected]);

  // CONTEXT API request (prefill)
  var makeContextGETRequest = (0, _react.useCallback)(() => {
    var queryParams = {
      a: 'query',
      src: getAddressQuery(addressQuerySource),
      searchType: 'match_phrase_prefix',
      environment,
      isProduction
    };
    return (0, _utils.makeHTTPRequest)(queryParams, _constants.HEADER_ACCESS_TOKEN, isProduction, _constants.HEADER_ACCESS_CONFIG_AMS_API_VALUE, 'prefillAddress', _constants.HTTP_GET);
  }, [addressQuerySource, environment, isProduction]);
  (0, _react.useEffect)(() => {
    if (clickedSubmit) {
      updateValidationError(addressValue);
      updateUnitNumberValidationError(unitNumberValue);
    }
  }, [clickedSubmit, updateValidationError, updateUnitNumberValidationError, addressValue, unitNumberValue]);
  (0, _react.useEffect)(() => {
    if (buttonControlPressed) {
      if ((0, _utils.isStepInput)(inputRef, currentStepReferences)) {
        updateValidationError(addressValue);
        updateUnitNumberValidationError(unitNumberValue);
      }
    }
  }, [buttonControlPressed, inputRef, currentStepReferences, updateValidationError, addressValue, updateUnitNumberValidationError, unitNumberValue]);

  //Debouncing API request
  (0, _react.useEffect)(() => {
    if (addressValue && !isAddSelected) {
      var getAMSData = setTimeout(() => {
        makeAMSGETRequest(addressValue).then(response => response.json()).then(resData => {
          setIsLoading(false);
          if (Array.isArray(resData)) {
            setItems(resData.map(data => ({
              id: data.id,
              label: (0, _utils.formatAddressLabel)(data),
              payload: data
            })));
          } else {
            _errorHandlerUtility.default.report(JSON.stringify({
              message: "AddressField: Expected an array but received a different type - ",
              fileName,
              methodName: 'getAMSData'
            }));
            setItems([]);
          }
        }).catch(error => {
          setIsLoading(false);
          _errorHandlerUtility.default.report(JSON.stringify({
            message: "AddressField: Failed to make a GET request and fetch data - ".concat(error),
            fileName,
            methodName: 'getAMSData'
          }));
        });
      }, 300);
      return () => clearTimeout(getAMSData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressValue]);

  // Add this useEffect hook
  (0, _react.useEffect)(() => {
    if (addressValue) {
      updateValidationError(addressValue);
    } else {
      setValidationError(undefined);
      setValidationFeedback(undefined);
    }
  }, [addressValue, selectedAddress, updateValidationError]);
  (0, _react.useEffect)(() => {
    if (isPrefill && !isAddSelected) {
      makeContextGETRequest().then(response => {
        if (response.status === 404) {
          return JSON.stringify([]);
        }
        if (!response.ok) {
          throw new Error("HTTP error with status: ".concat(response.status));
        }
        // Check response and avoid throwing an error if no data is returned
        return response.json();
      }).then(resData => {
        if (Array.isArray(resData)) {
          var mappedData = resData.map(data => ({
            id: data.id,
            label: (0, _utils.formatAddressLabel)(data),
            payload: data
          }));
          setItems(mappedData);
          if (mappedData.length > 0) {
            var payloadData = mappedData[0].payload;
            setSelectedAddress(payloadData.address);
            setAddressValue(payloadData.address);
            setIsAddSelected(true);
            setPayloadValue((0, _utils.addressFieldPayloadMapper)(payloadData, isLPDSIDRequired));
          }
        } else {
          _errorHandlerUtility.default.report(JSON.stringify({
            message: "AddressField: Expected an array but received a different type - ",
            fileName,
            methodName: 'makeContextGETRequest'
          }));
          setItems([]);
        }
      }).catch(error => {
        _errorHandlerUtility.default.report(JSON.stringify({
          message: "Failed to make a CONTEXT GET request and fetch data - ".concat(error),
          fileName,
          methodName: 'makeContextGETRequest'
        }));
      });
    }
  }, [isLPDSIDRequired, isPrefill, makeContextGETRequest]);

  // only during prefill
  // TODO: remove above useEffect and use this one
  (0, _react.useEffect)(() => {
    if (value && !isAddSelected) {
      var getAMSData = setTimeout(() => {
        makeAMSGETRequest(decodeURIComponent(value)).then(response => response.json()).then(resData => {
          setIsLoading(false);
          // check if resData is array then get the first element
          if (Array.isArray(resData)) {
            var mappedData = resData.map(data => ({
              id: data.id,
              label: (0, _utils.formatAddressLabel)(data),
              payload: data
            }));
            setItems(mappedData);
            if (mappedData.length > 0) {
              var payloadData = mappedData[0].payload;
              setSelectedAddress(payloadData.address);
              setAddressValue(payloadData.address);
              setIsAddSelected(true);
              setPayloadValue((0, _utils.addressFieldPayloadMapper)(payloadData, isLPDSIDRequired));
            }
          } else {
            _errorHandlerUtility.default.report(JSON.stringify({
              message: "AddressField: Expected an array but received a different type - ",
              fileName,
              methodName: 'makeContextGETRequest'
            }));
            setItems([]);
          }
        }).catch(error => {
          setIsLoading(false);
          _errorHandlerUtility.default.report(JSON.stringify({
            message: "AddressField: Failed to make a GET request and fetch data - ".concat(error),
            fileName,
            methodName: 'getAMSData'
          }));
        });
      }, 300);
      return () => clearTimeout(getAMSData);
    }
  }, [value]);

  //AMS API request
  var makeAMSGETRequest = strValue => {
    var queryParams = {
      a: 'query',
      src: getAddressQuery(addressQuerySource),
      searchType: 'match_phrase_prefix',
      maxResults: 5,
      text: strValue,
      environment,
      isProduction
    };
    return (0, _utils.makeHTTPRequest)(queryParams, _constants.HEADER_ACCESS_TOKEN, isProduction, _constants.HEADER_ACCESS_CONFIG_AMS_API_VALUE, 'addressList', _constants.HTTP_GET);
  };

  //OnChange set new string value
  var onFieldChange = newValue => {
    if (newValue !== selectedAddress && isAddSelected) {
      setIsAddSelected(false);
      setSelectedAddress('');
    }
    setAddressValue(newValue);
    setIsLoading(true);
    setItems([]);
  };

  //OnSelect set value as a address payload object
  var onSelect = id => {
    var selectedId = items.filter(item => {
      return item.id === id;
    });
    var payloadData = selectedId[0].payload;
    payloadData.unitNumber = unitNumberValue;
    setSelectedAddress(payloadData.address);
    setIsAddSelected(true);
    setPayloadValue((0, _utils.addressFieldPayloadMapper)(payloadData, isLPDSIDRequired));
  };
  var onUnitNumberFieldChange = newUnitNumberValue => {
    setUnitNumberValue(newUnitNumberValue);
    if (payloadValue) {
      payloadValue.unit = newUnitNumberValue;
      setPayloadValue(payloadValue);
    }
  };

  // Handle parent onchange on both address and unit number change
  (0, _react.useEffect)(() => {
    if (isAddSelected && payloadValue) {
      onChange(JSON.stringify(payloadValue), validateAddressAndUnitNumber(addressValue, isRequired, isAddSelected, unitNumberValue, unitNumberMaxLength));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressValue, unitNumberValue, payloadValue, isAddSelected]);
  (0, _react.useEffect)(() => {
    if (!isAddSelected && !value) {
      onChange(JSON.stringify(payloadValue), validateAddressAndUnitNumber(addressValue, isRequired, isAddSelected, unitNumberValue, unitNumberMaxLength));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_componentsWeb.StackView, {
    space: 2
  }, /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.Autocomplete, _extends({
    ref: inputRef,
    label: (0, _utils.formatLabel)(label, isRequired, language),
    hint: hint,
    hintPosition: hintPosition,
    placeholder: placeholder,
    feedback: validationError,
    validation: validationFeedback,
    items: items,
    value: addressValue,
    isLoading: isLoading,
    onChange: onFieldChange,
    onSelect: onSelect,
    loadingLabel: _staticContent.ADDRESS_FIELD.LOADING_LABEL[language],
    noResults: _staticContent.ADDRESS_FIELD.NO_RESULTS_LABEL[language]
  }, !isReadOnly && {
    onClear: () => {
      setSelectedAddress('');
      setIsAddSelected(false);
      setAddressValue('');
    }
  }, {
    inactive: isReadOnly
  }))), showUnitNumber && /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.TextInput, {
    label: (0, _utils.formatLabel)(unitNumberLabel, false, language),
    hint: unitNumberHint,
    hintPosition: hintPosition,
    type: _constants.INPUT_FIELD_TYPE.TEXT,
    value: unitNumberValue,
    placeholder: unitNumberPlaceholder,
    onChange: onUnitNumberFieldChange,
    onBlur: e => {
      updateUnitNumberValidationError(e.target.value);
    },
    maxLength: unitNumberMaxLength,
    validation: unitNumberFeedback,
    feedback: unitNumberError,
    inactive: isReadOnly
  })));
};
AddressField.propTypes = {
  label: _propTypes.default.string,
  hint: _propTypes.default.string,
  hintPosition: _propTypes.default.oneOf(['inline', 'below']),
  customErrorMessage: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  onChange: _propTypes.default.func,
  value: _propTypes.default.string,
  isRequired: _propTypes.default.bool,
  language: _propTypes.default.string,
  clickedSubmit: _propTypes.default.bool,
  inputRef: _propTypes.default.object,
  isProduction: _propTypes.default.bool,
  environment: _propTypes.default.string,
  unitNumberHint: _propTypes.default.string,
  unitNumberPlaceholder: _propTypes.default.string,
  unitNumberLabel: _propTypes.default.string,
  unitNumberMaxLength: _propTypes.default.number,
  unitNumberCustomErrorMessage: _propTypes.default.string,
  isReadOnly: _propTypes.default.bool,
  showUnitNumber: _propTypes.default.bool,
  loadingLabel: _propTypes.default.string
};
var _default = exports.default = AddressField;